import { Box, Typography } from '@mui/material';
import { PeopleAlt as PeopleAltIcon } from '@mui/icons-material';
import { useLanguage } from '../../../../context/LanguageContext';
import { primarySoft } from '../../../../theme';

interface TotalCountBannerProps {
    count: number;
    label: string;
}

function TotalCountBanner({ count, label }: TotalCountBannerProps) {
    const { formatLocale } = useLanguage();

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2, border: '2px solid', borderColor: 'primary.main', borderRadius: 2, bgcolor: (t) => primarySoft(t, 0.12) }}>
            <PeopleAltIcon sx={{ fontSize: 36, color: 'primary.main' }} />
            <Box>
                <Typography variant="h4" sx={{ fontWeight: 800, color: 'primary.main', lineHeight: 1.1 }}>
                    {count.toLocaleString(formatLocale)}
                </Typography>
                <Typography variant="body2" color="text.secondary">{label}</Typography>
            </Box>
        </Box>
    );
}

export default TotalCountBanner;
